import { Formulario } from './formulario';
import { Adjunto } from './adjunto';

export class CargaMasiva {
  ListaFormulario: Array<Formulario>;
  ListaAdjuntos: Array<Adjunto>;
  Sustento: string;
}
